export class IncomeType {
  public id?: string;
  public name: string;
}
